// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHONE = "Telef\u00f3n";
export const SIGNUP_AVATAR = "Fotoportr\u00e9t";
export const SIGNUP_TITLE = "Registr\u00e1cia";
